import { device } from '@framework/browser/device';

/**
 * Downloads document from external server
 *
 * @param {string} url
 */
export default function downloadFile(url: string) {
  if (device().mobile()) {
    (window as any).location = url;
    return;
  }

  let downloadIframe = document.getElementById('downloadFile');
  if (downloadIframe === null) {
    downloadIframe = document.createElement('iframe');
    downloadIframe.id = 'downloadFile';
    downloadIframe.setAttribute('style', 'display: none; visibility: hidden');
    document.body.appendChild(downloadIframe);
  }

  downloadIframe.setAttribute('src', url);
}
